import { SVGProps } from 'react';
const SvgArrowUpLeftSm = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16 16 8 8M8 14V8h6"
    />
  </svg>
);
export default SvgArrowUpLeftSm;
